<template>
    <div>
        <div v-if="!$route.query.itemId || ($route.query.itemId && $vuetify.breakpoint.mdAndUp)"
             :class="[{'navDrawer': $vuetify.breakpoint.mdAndUp},
                      {'navDrawerMob': $vuetify.breakpoint.smAndDown}]">
            <selection-list :list="ligen" hide-id="true"
                            @selected="selectLiga" large="true" group-by="type"
                            :group-header="(key) => { return getLigaTypeHeader(key)}">
                <!--:title="landesverbandLocal.nameShort.trim()"-->
                <div class="pt-3 pb-1">
                    <v-select v-model="verbandsAuswahl" :items="verbaende" outlined
                              label="Landesverband" hide-details ></v-select>
                </div>
                <div class="pt-3 pb-1">
                    <v-select v-model="sportJahr" :items="sportJahrList" outlined dense
                              label="Saison" hide-details></v-select>
                </div>
                <div v-if="user && (user.permissions.ergebnisdienst || isMeisterschaftAdmin)" class="pt-2">
                    <tool-tip v-if="user.permissions.ergebnisdienst" text="Neue Liga anlegen">
                        <v-btn icon @click="openLigaNew()">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </tool-tip>
                    <tool-tip text="Neue Meisterschaft anlegen">
                        <v-btn icon @click="openMeisterschaftNew()">
                            <v-icon>mdi-tournament</v-icon>
                        </v-btn>
                    </tool-tip>
                    <tool-tip v-if="user.permissions.ergebnisdienst" text="Verein für Testspiel anlegen">
                        <v-btn class="ml-1" icon @click="openDummyVereine()" v-if="id==='NationaleLigen'">
                            <v-icon>mdi-account-group</v-icon>
                        </v-btn>
                    </tool-tip>
                </div>
            </selection-list>
        </div>
        <div :class="[{'content pa-4': $vuetify.breakpoint.mdAndUp}, '']">
        <!-- alle spiele -->
            <spiele v-if="$route.query.itemId==='alleSpiele'" :lvId="id"
                    :sportJahr="sportJahr" :live-games="liveGames" :live-games-cup="liveGamesCup"
                    @refreshLiveGames="loadSaisonen" :saisonen="saisonen">
            </spiele>
        <!-- alle tabellen -->
            <tabellen v-else-if="$route.query.itemId==='alleTabellen'" :sportJahr="sportJahr"
                        :lvId="id" :saisonen="saisonen" :lv="landesverbandRaw">
            </tabellen>
        <!-- Doppelstart -->
            <doppel-start v-if="$route.query.itemId==='doppelStart' &&
                                (isSportobmann || user.permissions.ergebnisdienst)"
                :sportJahr="sportJahr" :lvId="id">
            </doppel-start>
        <!-- attest fehlt -->
            <attest-fehlt v-if="$route.query.itemId==='attestFehlt' &&
                                (isSportobmann || user.permissions.ergebnisdienst)"
                                :sportJahr="sportJahr" :lvId="id">
            </attest-fehlt>
        <!-- liga details -->
            <div v-else-if="$route.query.itemId!=='alleSpiele' &&
                                 $route.query.itemId!=='alleTabellen' &&
                                 $route.query.itemId!=='doppelStart' &&
                                 $route.query.itemId!=='attestFehlt'">
                <meisterschaft v-if="$route.query.itemId && liga?.type && meisterschaftTypes.includes(liga?.type)"
                               :sportJahr="sportJahr" :liga="liga" :landesverband="landesverbandLocal"
                               @meisterschaftAction="ligaAction"/>
                <liga v-else-if="$route.query.itemId"
                        :sportJahr="sportJahr" :liga="liga"
                        @ligaAction="ligaAction"
                        :landesverband="landesverbandLocal"></liga>
                <div v-else class="grey--text pa-5">
                    Bitte wähle die gewünschte Liga oder Übersicht aus dem Menü links!
                    <v-alert v-if="totalGamesLive>0"
                             class="mt-5" v-model="liveAlert" color="blue" border="left"
                             elevation="2" colored-border icon="mdi-alert-decagram">
                        <v-row align="center">
                            <v-col class="grow">
                                <div class="font-weight-bold mb-2" style="width: 170px">
                                    LIVE - es wird gespielt!
                                    <v-progress-linear rounded indeterminate color="blue">
                                    </v-progress-linear>
                                </div>
                                Du kannst im Moment
                                <span class="blue--text text--darken-2"><strong>{{totalGamesLive}}</strong></span>
                                Spiel<span v-if="totalGamesLive>1">e</span> live verfolgen!
                            </v-col>
                            <v-col class="shrink">
                                <v-btn color="blue" dark @click="selectLiga(alleSpiele)">
                                    Zu den Spielen ...
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-alert>
                    <img :src="require('../../assets/wappen/' + landesverbandLocal.wappen)"
                         width="300" class="logo">
                </div>
            </div>
            <snackbar :msg="deleteSnack">
            </snackbar>
        </div>
        <liga-edit :currentData="currentLiga" :landesverband="landesverband"
                   @changeLigaName="changeLigaName"></liga-edit>
        <meisterschaft-edit :currentData="currentLiga" :landesverband="landesverband"
                            @changeLigaName="changeLigaName"></meisterschaft-edit>
        <v-btn v-if="$vuetify.breakpoint.smAndDown" fab dark bottom right
               color="primary" style="position: fixed; right: 15px; bottom: 15px; z-index: 15" @click="back()">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <confirm-dialog :open="confirmDelete.open" :header="confirmDelete.header" :question="confirmDelete.question"
                        @reply="processConfirm" query-parameter="confirmLigaDelete">
        </confirm-dialog>
    </div>
</template>

<script>
    import Liga from "./liga";
    import SelectionList from "../../components/selectionList";
    import ToolTip from "../../components/elements/toolTip";
    import LigaEdit from "./ligaEdit";
    import {Landesverband} from "../../services/data/landesverband";
    import {firestore} from "../../services/db";
    import {db} from "../../services/db";
    import ConfirmDialog from "../../components/navigation/confirmDialog";
    import Snackbar from "../../components/elements/snackbar";
    import Tabellen from "./tabellen";
    import {Saison} from "../../services/data/saison";
    import TimeStamp from "../../services/timeStamp";
    import Spiele from "./spiele";
    import DoppelStart from "./doppelstart/doppelstart";
    import AttestFehlt from "@/views/ergebnisdienst/doppelstart/attestFehlt";
    import MeisterschaftEdit from "@/views/ergebnisdienst/meisterschaft/meisterschaftEdit";
    import Meisterschaft from "@/views/ergebnisdienst/meisterschaft/meisterschaft.vue";
    import FirebaseRead from "@/services/database/firebaseRead";

    export default {
        components: {
            Meisterschaft,
            MeisterschaftEdit,
            AttestFehlt,
            DoppelStart,
            Spiele,
            Tabellen,
            Snackbar,
            ConfirmDialog,
            LigaEdit,
            ToolTip,
            SelectionList,
            Liga},
        name: "region",
        props: ['id'],
        computed: {
            user(){ return this.$store.state.user; },
            isMeisterschaftAdmin(){ return this.$store.getters["user/isMeisterschaftAdmin"](this.landesverbandLocal.id)},
            landesverbandLocal(){
                return this.id !== 'NationaleLigen' ? this.$store.state.local.landesverbaende
                        .find(lv => lv.nameShort.trim() === this.id) :
                    this.$store.state.local.nationaleLigen;
            },
            landesverbandRaw(){
                return this.$store.state.realtime.landesverbaende[this.landesverbandLocal.id]; },
            totalGamesLive(){
                return this.liveGames.length + this.liveGamesCup.length
            },
            alleSpiele(){
                return {id: 'alleSpiele', name: 'alle Spiele',
                    nameFull: 'Alle Spiele', sort: -2, type: '',
                    addOn: (this.totalGamesLive === 0) || this.$vuetify.breakpoint.mdAndUp ? '' :
                            this.totalGamesLive === 1 ? ' - davon aktuell 1 Spiel live ...' :
                            ' - davon aktuell ' + this.totalGamesLive + ' Spiele live ...'}
            },
            ligen(){
                if ( this.landesverbandRaw ) {
                    let ligen = this.landesverband?.getArrayFromMap( this.landesverband.ligen);
                    if ( !ligen ) return []
                    const sportObmannRole = "sportobmann_" + this.landesverbandLocal.id;
                    for ( let i = 0; i < ligen.length; i++ ) {
                        const liga = ligen[i]
                        if ( liga.isCup ) liga.type = 'xc'
                        if ( this.user && this.user.permissions && !this.user.permissions.ergebnisdienst &&
                            !this.isMeisterschaftAdmin && !this.user.permissions[sportObmannRole]) {
                            const ligaSaison = liga.id + '_' + this.sportJahr;
                            if ( !this.saisonen.find(saison => saison.id === ligaSaison) &&
                                !liga.bewerbeSportJahr?.[this.sportJahr] ) {
                                ligen.splice(i,1);
                                i--;
                            }
                        } else if (this.user && this.user.permissions && !this.user.permissions.ergebnisdienst &&
                            this.isMeisterschaftAdmin && !liga.bewerbe && !this.user.permissions[sportObmannRole]) {
                            ligen.splice(i,1);
                        }
                    }
                    ligen.push( this.alleSpiele,
                        {id: 'alleTabellen', name: 'alle Tabellen',
                         nameFull: 'Alle Tabellen', sort: -1, type: ''}
                    );
                    if ( this.isSportobmann || this.user.permissions.ergebnisdienst) {
                        ligen.push(
                            {id: 'doppelStart', name: 'Doppelstart',
                                nameFull: 'Doppelstart Kontrolle', sort: 0, type: ''},
                        );
                        if ( this.landesverband.id==='14' || this.landesverband.id==='1' ) {
                            ligen.push(
                                {id: 'attestFehlt', name: 'Attest fehlt',
                                    nameFull: 'Einsatz ohne gültiges Attest', sort: 0, type: ''},
                            );
                        }
                    }
                    ligen.sort((a, b) => a.type > b.type ? 1 : -1 )
                         .sort((a, b) => a.sort - b.sort );
                    return ligen;
                } else {
                    return [];
                }
            },
            sportJahrList(){ return this.$store.state.local.sportJahr.adminListFull },
            isSportobmann(){
                const sportObmannRole = 'sportobmann_' + this.landesverbandLocal.id;
                return this.user.permissions[sportObmannRole] === true
            },
            ligaType(){ return this.$store.state.local.ligaTypes.find(type => type.value === this.liga.type) },
            ligaTypeLong(){ return this.landesverband?.id==='1' ? this.ligaType.labelLong : this.ligaType.labelLongAlt },
        },
        data: () => ({
            verbandsAuswahl: null,
            landesverband: null,
            liga: null,
            currentLiga: null,
            sportJahr: null,
            deleteSnack: {
                show: false,
                color: 'error',
                timeout: 4000,
                text: '',
                dynamicText: null,
                actionButtonI18n: '',
            },
            confirmDelete: {
                open: false,
                question: '',
                item: null,
            },
            verbaende: ['Nationale Ligen', 'Burgenland', 'Kärnten',
                        'Niederösterreich', 'Oberösterreich', 'Salzburg',
                        'Steiermark', 'Tirol', 'Vorarlberg', 'Wien'],
            liveAlert: true,
            saisonen: [],
            saisonenLoadTS: 0,
            liveGames: [],
            liveGamesCup: [],
            meisterschaftTypes: ['ösm', 'öms', 'ömj'],
        }),
        created(){
            this.setVerbandsAuswahl();
            this.sportJahr = this.$route.query.sportJahr ? this.$route.query.sportJahr :
                            JSON.parse(JSON.stringify( this.$store.state.local.sportJahr.current.value ));
            this.loadLandesVerband();
            if ( this.landesverbandRaw ) {
                this.setLandesverband();
                this.loadSaisonen();
            } else {
                this.$store.state.local.bindsRealtimeList = true;
            }
        },
        destroyed(){
            this.$store.state.local.bindsRealtimeList = false;
        },
        methods: {
            setVerbandsAuswahl(){
                if ( this.id === 'NationaleLigen' ) {
                    this.verbandsAuswahl = 'Nationale Ligen';
                } else {
                    this.verbandsAuswahl = this.id;
                }
            },
            back(){
                window.history.back();
            },
        // select liga (season is processed in liga component)
            selectLiga(liga){
                if ( liga.id !== this.$route.query.itemId ) {
                    let p = JSON.parse(JSON.stringify(this.$route.path));
                    let q = JSON.parse(JSON.stringify(this.$route.query));
                    q.itemId = liga.id;
                    if ( liga.bewerbe ) {
                        const sortedLigen = liga.bewerbe.sort((a, b) => a > b ? 1 : -1);
                        q.bewerbTyp = sortedLigen[0]
                    } else {
                        delete q.bewerbTyp
                    }
                    if ( this.$vuetify.breakpoint.smAndDown ) {
                        this.$router.push({path: p, query: q});
                    } else {
                        this.$router.replace({path: p, query: q});
                    }
                }
                this.liga = liga;
            },
        // get and format selections list group headers
            getLigaTypeHeader(searchKey){
                let item = this.$store.state.local.ligaTypes.find( type => type.value === searchKey );
                return item ? item.label.toUpperCase() : searchKey.toUpperCase();
            },
        // load and set landesverband
            loadLandesVerband(){
                this.liga = null;
                this.currentLiga = null;
                this.$store.dispatch('bindRealtimeDocument', {
                    collection: 'landesverbaende',
                    docId: this.landesverbandLocal.id,
                    storeField: 'landesverbaende.' + this.landesverbandLocal.id,
                    //emptyObject: new Landesverband()
                });
                this.landesverband = new Landesverband();
            },
            setLandesverband(){
                this.landesverband.setFromDataObject(this.landesverbandRaw);
                this.landesverband.id = this.landesverbandRaw.id;
            },
        // create, edit & delete liga
            openDummyVereine(){
                this.$router.push('/Ergebnisdienst/DummyVereine');
            },
            openLigaNew(){
                this.currentLiga = null;
                this.openLigaEdit();
            },
            openMeisterschaftNew(){
                this.currentLiga = null;
                this.openMeisterschaftEdit();
            },
            openLigaEdit(){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'editLiga';
                this.$router.push({path: p, query: q});
            },
            openMeisterschaftEdit(){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'editMeisterschaft';
                this.$router.push({path: p, query: q});
            },
            changeLigaName(dataObject){
                this.liga.name = dataObject.name;
                this.liga.fullName = dataObject.fullName;
                this.liga.noRanking = dataObject.noRanking;
                this.liga.keineDoppelstartKontrolle = dataObject.keineDoppelstartKontrolle;
            },
            ligaAction(action){
                if ( action === 'edit' ) {
                    this.currentLiga = JSON.parse(JSON.stringify(this.liga));
                    if ( this.currentLiga?.type && this.meisterschaftTypes.includes(this.currentLiga?.type) ) {
                        this.openMeisterschaftEdit()
                    } else {
                        this.openLigaEdit();
                    }
                } else if (action === 'delete') {
                    this.deleteLiga();
                }
            },
            deleteLiga(){
            // delete Meisterschaften
                if ( this.meisterschaftTypes.includes(this.liga.type) ) {
                    if ( (this.liga.bewerbeCounter.f + this.liga.bewerbeCounter.m + this.liga.bewerbeCounter.x) > 0) {
                        this.deleteSnack.text = 'Diese Meisterschaft kann nicht gelöscht werden ' +
                            'weil bereits Bewerbe angelegt wurden! Bitte zuerst alle Bewerbe löschen.',
                            this.deleteSnack.color = 'error';
                        this.deleteSnack.show = true;
                    } else {
                        this.requestDeleteConfirm('meisterschaft');
                    }
            // delete Liga
                } else {
                    db.collection("saisonen").where("ligaId", "==", this.liga.id)
                        .get()
                        .then((querySnapshot) => {
                            let saisonenCount = 0;
                            querySnapshot.forEach((doc) => {
                                // doc.data() is never undefined for query doc snapshots
                                console.log(doc.id, " => ", doc.data());
                                saisonenCount++;
                            });
                            if ( saisonenCount > 0 ) {
                                this.deleteSnack.text = 'Diese Liga kann nicht gelöscht werden ' +
                                    'weil bereits Saisonen angelegt wurden! Bitte zuerst alle Saisonen löschen.',
                                    this.deleteSnack.color = 'error';
                                this.deleteSnack.show = true;
                            } else {
                                this.requestDeleteConfirm('liga');
                            }
                        })
                        .catch((error) => {
                            console.log("Error getting documents: ", error);
                        });
                }
            },
                requestDeleteConfirm(type){
                    if ( type === 'meisterschaft' ) {
                        const ligaType = this.$store.state.local.ligaTypes.find( type => type.value === this.liga.type );
                        this.confirmDelete.header = 'Meisterschaft löschen';
                        this.confirmDelete.question = "Möchtest du die '" + this.landesverbandLocal?.prefix + this.ligaTypeLong + ' ' + this.liga.name +
                            "' wirklich endgültig löschen?";
                    } else {
                        this.confirmDelete.header = 'Liga löschen';
                        this.confirmDelete.question = "Möchtest du die Liga '" + this.liga.nameFull +
                            "' wirklich endgültig löschen?";
                    }
                    this.confirmDelete.open = true;
                },
                processConfirm(reply) {
                    if ( reply ) {
                        this.processDeletion();
                    }
                    this.confirmDelete.open = false;
                },
                async processDeletion(){
                    this.landesverband.local.documentUpdates = {
                        ['ligen.' + this.liga.id]: firestore.FieldValue.delete()
                    };
                    let reply = await this.landesverband.saveEdited();
                    if ( reply.successful ) {
                        this.deleteSnack.text = this.meisterschaftTypes.includes(this.liga.type) ?
                            'Die Meisterschaft wurde erfolgreich gelöscht!' : 'Die Liga wurde erfolgreich gelöscht!';
                            this.deleteSnack.color = 'success';
                        this.deleteSnack.show = true;
                        this.liga = null;
                    }
                },
        // saisonen
            loadSaisonen(){
                if ( this.landesverbandRaw &&
                    this.landesverbandRaw.ligen ) {
                    const currentTS = TimeStamp.getGMTTimestamp();
                    if ( currentTS - this.saisonenLoadTS < 5000 ) { return }
                    this.saisonen = [];
                    this.liveGames = [];
                    this.liveGamesCup = [];
                    this.$store.state.local.bindsRealtimeList =
                        Object.keys(this.landesverbandRaw.ligen).length > 0;
                    this.saisonenLoadTS = currentTS;
                    Object.keys(this.landesverbandRaw.ligen).forEach( (ligaId) => {
                        const docId = ligaId + '_' + this.sportJahr;
                        db.collection('saisonen').doc(docId).get()
                            .then((doc) => {
                                if (doc.exists) {
                                    this.loadSaisonenInitSaison(doc, docId, ligaId);
                                    this.$store.state.local.bindsRealtimeList = false;
                                } else {
                                    // doc.data() will be undefined in this case
                                    console.log("No such document!");
                                    this.$store.state.local.bindsRealtimeList = false;
                                }
                            }).catch((error) => {
                            console.log("Error getting document:", error);
                        });
                    });
                }
            },
                loadSaisonenInitSaison(doc, docId, ligaId){
                    let saisonTemp = doc.data();
                    saisonTemp.id = docId;
                    const saison = new Saison();
                    saison.setFromDataObject(saisonTemp);
                    saison.local.title = this.landesverbandRaw.ligen[ligaId].nameFull;
                    saison.local.sort = this.landesverbandRaw.ligen[ligaId].sort;
                    this.saisonen.push(saison);
                    this.saisonen.sort((a, b) => a.local.sort > b.local.sort ? 1 : -1);
                // getLiveGames
                    const liveGames = saison.getLiveGames();
                    if ( saison.isCup ) {
                        const currentLiveGamesCup = JSON.parse(JSON.stringify(this.liveGamesCup));
                        if ( liveGames.length > 0 ) this.liveGamesCup = currentLiveGamesCup.concat(liveGames)
                    } else {
                        const currentLiveGames = JSON.parse(JSON.stringify(this.liveGames));
                        if ( liveGames.length > 0 ) this.liveGames = currentLiveGames.concat(liveGames)
                    }
                },
            setItemFromQuery(){
                let item = this.ligen.find(item => item.id == this.$route.query.itemId );
                if ( item ) { this.selectLiga(item); }
            },
        },
        watch: {
            landesverbandRaw(){
                if ( this.landesverbandRaw ) { this.setLandesverband(); }
                this.loadSaisonen();
            },
            sportJahr(){
                this.saisonenLoadTS = 0;
                this.loadSaisonen();
            },
            /*sportJahr(){
                if ( this.landesverband && this.landesverband.id && this.liga ) {
                    this.selectLiga(this.liga);
                }
            },*/
            verbandsAuswahl(){
                const selected = this.verbandsAuswahl.replace(' ', '');
                if ( selected !== this.id ) {
                    this.$router.replace({ name: 'Region', params: { id: selected.trim() } })
                }
            },
            id(){
                console.log ("WATCH ID !!!!!!!!!!!!!!!!!!!!!");
                this.loadLandesVerband();
                this.setVerbandsAuswahl();
                this.saisonenLoadTS = 0;
                this.loadSaisonen();
            },
            '$route.query.itemId'(){
                if ( this.$route.query.itemId === 'alleTabellen' ||
                    this.$route.query.itemId === 'alleSpiele' ) {
                    this.loadSaisonen();
                }
            },
            ligen(){
                if(this.$route.query.itemId && !this.$vuetify.breakpoint.mdAndUp) this.setItemFromQuery();
            },
        },
    }
</script>

<style scoped>
    .navDrawer { position: fixed; bottom: 0; border-right: solid 1px lightgrey;
        top: 48px; left: 0; width: 200px; overflow-y: auto;}
    .navDrawerMob { position: fixed; bottom: 0; border-right: solid 1px lightgrey;
        top: 48px; left: 0; right: 0; background-color: white; z-index: 1; overflow-y: auto}
    .content { position: fixed; bottom: 0; top: 48px; right: 0;
        left: 200px; overflow-y: auto; background-color: #f2f2f2}
    .logo {     position: absolute;   -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%); opacity: 0.3;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);}
    .selected { background-color: #f2f2f2 }
    .item:hover { background-color: #f2f2f2; cursor: default }
</style>